"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'FormTextArea',
  props: {
    val: {
      type: String,
      default: ''
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 类型
    rows: {
      type: Number,
      default: 3
    },
    // 是否显示限制（必须填了最大长度才显示）
    showWordLimit: {
      type: Boolean,
      default: true
    },
    // 是否可以resize [none, both, horizontal, vertical]
    resize: {
      type: String,
      default: 'none'
    },
    change: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      inputVal: this.val
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    }
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.inputVal = newVal;
      }
    }
  },
  methods: {
    onInput: function onInput(val) {
      if (this.isDisabled) {
        return false;
      }
      this.$emit('update:val', val);
      this.change(val);
    }
  }
};